import qs from 'querystring'
 
import _ from 'underscore'
import Api from '../lib/request'
import { itemList } from '../mock/item'
import cookie from '../lib/cookie'
import COOKIECONSTANT from '../constant/cookie'


const getItemBuyer = (id) => {
    return new Promise((resolve, reject) => {
        const url = `${COOKIECONSTANT.REQUEST_HOST}?productId=${id}`
        // Api.get('http://localhost:3000/buyer', {
        Api.get(url, {
            headers: {
                'X-Host': 'mall.cfg.buyer-show.brief',
                'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        }).then((data) => {
            if (data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, (e) => {
            reject(e)
        })
    })
}



const getBuyerInfo = (id) => {
    return new Promise((resolve, reject) => {
        const url = `${COOKIECONSTANT.REQUEST_HOST}?buyerId=${id}`
        Api.get(url, {
            headers: {
                'X-Host': 'mall.cfg.buyer.info',
                'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        }).then((data) => {
            if (data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, (e) => {
            reject(e)
        })
    })
}

const getBuyerShowInfo = (id) => {
    return new Promise((resolve, reject) => {
        const url = `${COOKIECONSTANT.REQUEST_HOST}?productId=${id}`
        Api.get(url, {
            headers: {
                'X-Host': 'mall.cfg.buyer-show.info',
                'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        }).then((data) => {
            if (data.status !== 0) {
                return reject(data.msg)
            }
            resolve(data.data)
        }, (e) => {
            reject(e)
        })
    })
}

const getBuyerShowList = (options) => {
    return new Promise((resolve, reject) => {
        const url = `${COOKIECONSTANT.REQUEST_HOST}?${qs.stringify(options)}`
        Api.get(url, {
            headers: {
                'X-Host': 'mall.cfg.buyer-show.list',
                'X-Token': cookie(COOKIECONSTANT.COOKIE_USER_X_TOKEN),
            }
        }).then((data) => {
            if (data.status !== 0) {
                return reject(data)
            }
            resolve(data.data)
        }, (e) => {
            reject(e)
        })
    })
}

/*yeoman-template-point-1*/
export default {
    getItemBuyer,
    getBuyerInfo,
    getBuyerShowInfo,
    getBuyerShowList
    /*yeoman-template-point-2*/
}
